import { Box, BoxProps, Icon, Image, Text, TextProps } from '@jfs/ui-new'
import { UpiIcon } from '../../assets/images/svg/Upi'

interface UPIListItemProps {
  item: { base64AppIcon: string; appName: string; packageName: any }
  onItemPress: (item: any) => void
  theme: any
  selectedUpiPackageName: string
}

const UPIListItem = ({ item, onItemPress, theme, selectedUpiPackageName }: UPIListItemProps) => {
  const styles = Styles(theme)
  return (
    <Box {...styles.container} onPress={() => onItemPress(item)}>
      <Box {...styles.imageContainer}>
        {item.base64AppIcon ? (
          <Image source={'data:image/png;base64, ' + item.base64AppIcon} width={24} height={24} />
        ) : (
          <UpiIcon size={24} selected={true} />
        )}
      </Box>
      <Box {...styles.rightContainer}>
        <Box {...styles.textContainer}>
          <Text {...styles.textStyle}>{item.appName}</Text>
        </Box>
        {selectedUpiPackageName === item.packageName && (
          <Box {...styles.tick}>
            <Icon id="ROUND_TICK_FILLED" color={theme?.brandColor} size={20} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

const Styles = (theme: any) => ({
  container: {
    height: 65,
    alignItems: 'center',
    flexDirection: 'row',
    underlayColor: 'WHITE',
  } as BoxProps,
  imageContainer: {
    marginHorizontal: 20,
  } as BoxProps,
  rightContainer: {
    height: '100%',
    borderBottomColor: 'BORDER_COLOR',
    borderBottomWidth: 1,
    flexDirection: 'row',
    flex: 1,
  } as BoxProps,
  textContainer: {
    flex: 1,
    height: '100%',
    justifyContent: 'center',
  } as BoxProps,
  text: {
    fontFamily: 'jioType-medium',
    fontSize: 14,
    color: theme.bodyTextColor,
  } as TextProps,
  tick: {
    justifyContent: 'flex-end',
    marginHorizontal: 20,
    alignSelf: 'center',
  } as BoxProps,
  textStyle: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: theme.bodyTextColor,
  } as TextProps,
})

export { UPIListItem }
